module.exports = __webpack_public_path__ + "img/reply.14328432.svg";